// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"88":"login-page","316":"register-page","489":"rcontacts-page"}[chunkId] + "." + {"88":"d690880d","316":"436a8935","489":"a3ca5ffd"}[chunkId] + ".chunk.css";
};